import { render, staticRenderFns } from "./ExaminationInfo.vue?vue&type=template&id=3556040e"
import script from "./ExaminationInfo.vue?vue&type=script&lang=js"
export * from "./ExaminationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports